import React, { useCallback, useState } from 'react';

import { observer } from 'mobx-react';

import { Footer } from '../../../../components/Footer/Footer';
import { useJackpotStart } from '../../../../components/GamesList/useJackpotStart';
import classes from '../../../../components/headers/Headers.module.scss';
import { Loader } from '../../../../components/Loader/Loader';
import { MOBILE_MEDIA_QUERY } from '../../../../config/constants';
import { useMediaQuery } from '../../../../hooks/useMediaQuery';
import { useHomeContentLogic } from '../../../../pages/Home/useHomeContentLogic';
import { useHomeResetScroll } from '../../../../pages/Home/useHomeResetScroll';
import { useStores } from '../../../../stores/useStores';
import { GamesHero } from '../GamesHero/GamesHero';
import { GamesView } from '../GamesView/GamesView';
import { LobbyCategoriesBar } from '../LobbyCategoriesBar/LobbyCategoriesBar';
import { Widgets } from '../Widgets/Widgets';

import styles from './LobbyMainView.module.scss';

const MOBILE_TOP_OFFSET = 240;
const DESKTOP_TOP_OFFSET = 480;

function LobbyMainViewComponent() {
  const { headerHeight } = useHomeContentLogic();
  const isHeaderReady = headerHeight > 0;
  const isMobile = useMediaQuery(MOBILE_MEDIA_QUERY);
  const topOffset = isMobile ? MOBILE_TOP_OFFSET : DESKTOP_TOP_OFFSET;
  const [isScrolled, setIsScrolled] = useState(false);
  const { coinTypeStore } = useStores();
  const { coinType } = coinTypeStore;

  useHomeResetScroll();
  useJackpotStart();

  const handleScroll = useCallback(
    (e: React.UIEvent<HTMLDivElement>) => {
      const offset = e.currentTarget.scrollTop;
      if (offset > 0 && offset < topOffset) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    },
    [topOffset],
  );

  return (
    <div className={styles.container}>
      <div className={styles.headerScrollGradientContainer} style={{ opacity: isScrolled ? 1 : 0 }}>
        <div className={styles.headerScrollGradient} />
      </div>
      <div className={coinType === 'GC' ? styles.headerBackgroundGCOuter : classes.headerScrollBackgroundSCOuter}>
        <div className={styles.headerBackgroundInner} />
      </div>
      {isHeaderReady ? (
        <div className={styles.contentWrapper} onScroll={handleScroll}>
          <div className={styles.topContent}>
            <GamesHero />
            <Widgets />
          </div>
          <LobbyCategoriesBar />
          <GamesView />
          <Footer />
        </div>
      ) : (
        <Loader />
      )}
    </div>
  );
}

export const LobbyMainView = observer(LobbyMainViewComponent);
